<template>
    <div class="space-y-6">
        <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 transition-all duration-200 ease-in-out">
            <div class="md:grid md:grid-cols-3 md:gap-6" v-if="!product.saved">
                <div class="md:col-span-1">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Sale Type</h3>
                    <p class="mt-1 text-sm text-gray-500">What type of sale is this?</p>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <form class="space-y-6" method="POST" @submit.prevent>
                        <div>
                            <div class="flex justify-center mt-4">
                                <Listbox as="div" v-model="type" v-if="saleTypes" class="w-full">
                                    <div class="mt-1 relative w-full">
                                        <ListboxButton class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <span class="block truncate">{{ type?.label ?? 'Choose A Sale Type' }}</span>
                                            <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
                                            </span>
                                        </ListboxButton>

                                        <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                                            <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                                <ListboxOption as="template" v-for="saleType in saleTypes" :key="saleType.key" :value="saleType" v-slot="{ active, selected }">
                                                    <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
                                                        <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">{{ saleType.label }}</span>
                                                        <span v-if="selected" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                                            <CheckIcon class="h-5 w-5" aria-hidden="true"/>
                                                        </span>
                                                    </li>
                                                </ListboxOption>
                                            </ListboxOptions>
                                        </transition>
                                    </div>
                                </Listbox>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="md:grid md:grid-cols-3 md:gap-6" v-if="product.saved">
                <div class="md:col-span-1 flex">
                    <CheckCircleIcon class="h-6 w-6 text-green-600 mr-4" />
                    <h3 class="text-lg font-medium leading-6 text-gray-900 flex-1">Sale Type</h3>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <p class="font-normal text-md">
                        {{ type.label }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from "@headlessui/vue"
import {CheckIcon, ChevronUpDownIcon, XMarkIcon} from "@heroicons/vue/24/solid"
import {CheckCircleIcon, ChevronDownIcon, EyeIcon, EyeSlashIcon, ArrowPathIcon} from "@heroicons/vue/24/outline"
import {onMounted, ref, toRef, watch} from "vue"

const saleTypes = [
    {
        key: 'subscription',
        label: 'New subscription',
    },
    {
        key: 'addon',
        label: 'Addons for existing subscription',
    },
    {
        key: 'single',
        label: 'Single-item purchase',
    }
]

export default {
    name: "SaleType",
    props: {
        type: {
            type: Object,
            required: true,
        },
        product: {
            type: Object,
            required: false
        }
    },
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ChevronUpDownIcon,
        XMarkIcon,
        ChevronDownIcon,
        EyeIcon,
        EyeSlashIcon,
        CheckCircleIcon,
    },
    emits: [
        'update',
    ],
    setup(props, context) {
        const state = toRef(props, 'type')
        const product = toRef(props, 'product')

        const type = ref({})

        watch(() => type.value, (newValue, oldValue) => {
            context.emit('update', newValue)
        }, {deep: true})

        onMounted(() => {
            type.value = saleTypes[0]
        })

        return {
            state,
            type,
            saleTypes,
            product,
        }
    }
}
</script>
